﻿import { Inject, Pipe, Injectable } from "@fiqas/angular-utils"
import { FIQAssist } from "../app";
import { TranslationService } from "../services/TranslationService";
import { LocalizationData } from "../models/localization";

export class TranslationFilter {

    @Pipe({
        module: FIQAssist,
        selector: 'translate',
        pure: false
    })
    public static TranslationFilter( @Inject('TranslationService') translationService: TranslationService) {

        return (key: string): string => {
            return translationService.Translate(key);
        };
    }

    @Pipe({
        module: FIQAssist,
        selector: 'translateAvailable',
        pure: false
    })
    public static TranslationAvailabileFilter( @Inject('TranslationService') translationService: TranslationService) {

        return (key: string): string => {
            return translationService.Translate(key, true);
        };
    }
}
